import isSameDay from '../is-same-day';
import subtractDays from '../subtract-days';
import toDate from '../to-date';

export const isYesterday = (date: Date | number): boolean => {
  const formattedDate = toDate(date);

  return isSameDay(formattedDate, subtractDays(Date.now(), 1));
};

export default isYesterday;
